<template>
    <div>
        <div class="banner1">
            <img src="../assets/img/banner5.jpg" alt="banner" />
        </div>

        <div class="block">
            <div class="center">
                <div class="left_bar">
                    <div class="title">客户与联盟</div>
                    <ul>
                        <li><a href="javascript:void(0);" @click.stop="goTo('WoMenDeKeHu')">我们的客户</a></li>
                        <li><a href="javascript:void(0);" @click.stop="goTo('HeZuoHuoBan')">合作伙伴</a></li>
                        <li><a href="javascript:void(0);" @click.stop="goTo('HeZuoJiGouYuGaoXiao')">合作机构与高校</a></li>
                        <li><a href="javascript:void(0);" @click.stop="goTo('KeHuYuLianMengView1?customersType=604&id=14')">联盟与协会</a></li>
                    </ul>
                </div>
                <div class="right_contnet">
                    <h2>{{ article.title }}</h2>
                    <div class="product_view">
                        <div class="main_content" v-html="article.content"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { KeHuYuLianMeng } from "../request/api"; // 导入接口

export default {
    name: 'Home',
    data() {
        return {
            title: '客户与联盟',
            sub_title: '',
            windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
            windowHeight: document.documentElement.clientHeight, //实时屏幕高度

            id: this.$route.query.id, //传入的id
            customersType : this.$route.query.customersType, //传入的customersType

            article: {
                title:'',
                datetime:'',
                content:''
            },
        };
    },
    created() {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
        this.KeHuYuLianMeng_data();
    },
    mounted() {
        window.onresize = () => {
            //页面改变尺寸时
            return (() => {
                this.windowWidth = document.documentElement.clientWidth;
                this.windowHeight = document.documentElement.clientHeight;
            })();
        };
    },
    methods: {
        goTo(e) {
            this.$router.push(e);
        },
        KeHuYuLianMeng_data(){ //文章分类显示
            KeHuYuLianMeng({
                customersType: this.customersType,
                id: this.id,
            }).then((res) => {
                console.log( res );
               
                this.article.title = res.rows[0].customersTitle;
                this.article.datetime = res.rows[0].createDate;
                this.article.content = res.rows[0].customersDetails;
            });
        },
    },
};
</script>
<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/KeHuYuLianMengView1.vue